import { GoatAwkward, useIntl } from '@capsicum/common';
import { GenericDrawer } from '@capsicum/common-web';

export type NCRegistrationErrorDrawerProps = {
	onConfirm: () => void;
	testID: string;
};

export const NCRegistrationExistingUserDrawer = ({ onConfirm, testID }: NCRegistrationErrorDrawerProps) => {
	const { $t } = useIntl();

	const ncRegistrationErrorDrawerData = {
		buttonText: $t('ncOnboarding.registration.existingUserButton'),
		description: $t('ncOnboarding.registration.existingUserDesc'),
		image: GoatAwkward,
		onButtonPress: onConfirm,
		testID: testID,
		title: $t('ncOnboarding.registration.existingUserTitle')
	};

	return <GenericDrawer {...ncRegistrationErrorDrawerData}></GenericDrawer>;
};
